import React, { useState } from "react";
import {
  FaBars,
  FaTimes,
  FaGithub,
  FaGitlab,
  FaLinkedin,
  FaTelegram,
} from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";
import { BsPersonLinesFill } from "react-icons/bs";
import Logo from "../assets/icons/icon-logo.png";
import { Link } from "react-scroll";

const Navbar = (props) => {
  const [nav, setNav] = useState(false);
  const handleClick = () => setNav(!nav);

  const background = props.backgroundColor;
  console.log(background);

  return (
    <div
      className={`fixed w-full h-[4rem] flex justify-between shadow-lg items-center px-4 z-20 bg-opacity-50 fixed-backdrop-blur bg-[${background}] text-cyan-100`}
    >
      <div className="px-3">
        <img src={Logo} alt="Logo" style={{ width: "50px" }} />
      </div>

      {/* menu */}
      <ul className="hidden md:flex items-center gap-2">
        <li>
          <Link
            className="hover:text-[#ffffff] transition-colors duration-300"
            to="home"
            smooth={true}
            duration={500}
          >
            Home
          </Link>
        </li>
        <li>
          <Link
            className="hover:text-[#ffffff] transition-colors duration-300"
            to="about"
            smooth={true}
            duration={500}
          >
            About
          </Link>
        </li>
        <li>
          <Link
            className="hover:text-[#ffffff] transition-colors duration-300"
            to="experience"
            smooth={true}
            duration={500}
          >
            Experience
          </Link>
        </li>
        <li>
          <Link
            className="hover:text-[#ffffff] transition-colors duration-300"
            to="skills"
            smooth={true}
            duration={500}
          >
            Skills
          </Link>
        </li>
        <li>
          <Link
            className="hover:text-[#ffffff] transition-colors duration-300"
            to="work"
            smooth={true}
            duration={500}
          >
            Projects
          </Link>
        </li>
        <li>
          <Link
            className="hover:text-[#ffffff] transition-colors duration-300"
            to="contact"
            smooth={true}
            duration={500}
          >
            Contact
          </Link>
        </li>
        <li className="hidden lg:flex items-center justify-center">
          <a
            href="https://drive.google.com/file/d/1Aj8UBkV1EenyZes903PND6iDZ5qQfSqj/view?usp=sharing"
            target="_blank"
            rel="noopener noreferrer"
            className="hidden lg:flex items-center justify-center rounded-lg text-white border-2 px-5 py-2 hover:bg-cyan-600 hover:border-cyan-700 duration-500 animated-border"
          >
            Resume
          </a>
        </li>
      </ul>

      {/* hamburger menu */}
      <div onClick={handleClick} className="flex md:hidden z-10">
        {nav ? <FaTimes size="25" /> : <FaBars size="25" />}
      </div>

      {/* mobile menu */}
      <ul
        className={
          nav
            ? "absolute md:hidden top-0 left-0 h-screen flex flex-col justify-center items-center w-full bg-[#0a192f] z-20"
            : "hidden"
        }
      >
        {/* Close button */}
        <div className="absolute top-4 right-4">
          <button
            onClick={handleClick}
            className="text-gray-300 hover:text-white"
          >
            <FaTimes size="25" />
          </button>
        </div>

        <li className="py-4 text-4xl">
          <Link
            onClick={handleClick}
            className="hover:text-cyan-500 transition-colors duration-300"
            to="home"
            smooth={true}
            duration={500}
          >
            Home
          </Link>
        </li>
        <li className="py-4 text-4xl">
          <Link
            onClick={handleClick}
            className="hover:text-cyan-500 transition-colors duration-300"
            to="about"
            smooth={true}
            duration={500}
          >
            About
          </Link>
        </li>
        <li className="py-4 text-4xl">
          <Link
            onClick={handleClick}
            className="hover:text-cyan-500 transition-colors duration-300"
            to="experience"
            smooth={true}
            duration={500}
          >
            Experience
          </Link>
        </li>
        <li className="py-4 text-4xl">
          <Link
            onClick={handleClick}
            className="hover:text-cyan-500 transition-colors duration-300"
            to="skills"
            smooth={true}
            duration={500}
          >
            Skills
          </Link>
        </li>
        <li className="py-4 text-4xl">
          <Link
            onClick={handleClick}
            className="hover:text-cyan-500 transition-colors duration-300"
            to="work"
            smooth={true}
            duration={500}
          >
            Projects
          </Link>
        </li>
        <li className="py-4 text-4xl">
          <Link
            onClick={handleClick}
            className="hover:text-cyan-500 transition-colors duration-300"
            to="contact"
            smooth={true}
            duration={500}
          >
            Contact
          </Link>
        </li>

        {/* Social icons in mobile menu */}
        <div className="flex justify-center gap-6 mt-8">
          <a
            href="https://t.me/bk25119"
            className="text-gray-300 hover:text-cyan-500 transition-colors duration-300"
          >
            <FaTelegram size={30} />
          </a>
          <a
            href="mailto:bk14drobs@gmail.com"
            className="text-gray-300 hover:text-cyan-500 transition-colors duration-300"
          >
            <HiOutlineMail size={30} />
          </a>
          <a
            href="https://gitlab.com/Beki-D"
            className="text-gray-300 hover:text-cyan-500 transition-colors duration-300"
          >
            <FaGitlab size={30} />
          </a>
          <a
            href="https://github.com/Beki-D"
            className="text-gray-300 hover:text-cyan-500 transition-colors duration-300"
          >
            <FaGithub size={30} />
          </a>
          <a
            href="linkedin.com/in/beki-d-abate-818222233"
            className="text-gray-300 hover:text-cyan-500 transition-colors duration-300"
          >
            <FaLinkedin size={30} />
          </a>
          <a
            href="https://drive.google.com/file/d/1Aj8UBkV1EenyZes903PND6iDZ5qQfSqj/view?usp=sharing"
            className="text-gray-300 hover:text-cyan-500 transition-colors duration-300"
          >
            <BsPersonLinesFill size={30} />
          </a>
        </div>
      </ul>

      {/* social icons */}
      <div className="hidden lg:flex fixed flex-col top-64 left-0">
        <ul>
          <li className="w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-blue-600 bg-opacity-30">
            <a
              className="flex justify-between w-full text-gray-300"
              href="https://t.me/bk25119"
            >
              Telegram <FaTelegram size={30} />
            </a>
          </li>
          <li className="w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-cyan-500 bg-opacity-30">
            <a
              className="flex justify-between w-full text-gray-300"
              href="mailto:bk14drobs@gmail.com"
            >
              Email <HiOutlineMail size={30} />
            </a>
          </li>
          <li className="w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-[#333333] bg-opacity-30">
            <a
              className="flex justify-between w-full text-gray-300"
              href="https://gitlab.com/Beki-D"
            >
              Gitlab <FaGitlab size={30} />
            </a>
          </li>
          <li className="w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-[#333333] bg-opacity-30">
            <a
              className="flex justify-between w-full text-gray-300"
              href="https://github.com/Beki-D"
            >
              Github <FaGithub size={30} />
            </a>
          </li>
          <li className="w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-[#0077b5] bg-opacity-30">
            <a
              className="flex justify-between w-full text-gray-300"
              href="linkedin.com/in/beki-d-abate-818222233"
            >
              LinkedIn <FaLinkedin size={30} />
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Navbar;
